import FlagsContext from './component'
export default FlagsContext
